import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["newExpenseCategory", "expenseSelect", "createExpenseCategoryButton", "createExpenseCategoryTextField"]

  connect() {
    this.createExpenseCategoryTextFieldTarget.value = ""
  }

  createExpense() {
    this.expenseSelectTarget.classList.toggle("hidden")
    this.newExpenseCategoryTarget.classList.toggle("hidden")
    this.createExpenseCategoryButtonTarget.classList.toggle("hidden")
    this.createExpenseCategoryTextFieldTarget.value = ""
    this.createExpenseCategoryTextFieldTarget.required = true
    this.createExpenseCategoryTextFieldTarget.focus()
  }

  showTooltipExpenseCategoryLabel () {
    $(".expense-category-label").tooltipster({
      functionReady: function(instance) {
        $(".title-tooltip span.close").click(function() {
          instance.close();
        });
      },
      theme: ["tooltipster-shadow"],
      interactive: true,
      delay: 600,
      contentAsHTML: true,
      maxWidth: 400,
      minWidth: 300
    });
    $(".expense-category-label").tooltipster(
      "content",
        "<div class='title-tooltip appointment-tooltip clearfix'>"
          + "<div class='tw-underline' style='max-width: 350px; float: left;'>Para excluir ou alterar uma categoria, <a href='/expense_categories'>clique aqui</a></div></div>"
    );
    $(".expense-category-label").tooltipster("open");
  }
}
